
import { Badge } from "@/components/ui/badge";
import { CardTitle, CardDescription } from "@/components/ui/card";
import { formatDate } from "@/utils/dateUtils";
import { useTranslation } from "react-i18next";
import { getStatusBadgeStyle } from "../ClientUtils";
import { getStatusText, getMemberSinceDate } from "@/utils/clientUtils";
import { Client } from "@/types/types";

interface ClientHeaderProps {
  client: Client;
}

export function ClientHeader({ client }: ClientHeaderProps) {
  const { t } = useTranslation(["clients", "subscriptions"]);
  const memberSince = getMemberSinceDate(client);

  return (
    <>
      <div className="flex justify-between items-start">
        <Badge 
          variant="default" 
          className={getStatusBadgeStyle(client.status || "Active")}>
          {t(getStatusText(client.status), { ns: 'subscriptions' })}
        </Badge>
      </div>
      <CardTitle className="text-2xl font-bold">
        {client.firstName} {client.lastName}
      </CardTitle>
      <CardDescription className="flex flex-col space-y-1 mt-1">
        <span>
          {t("memberSince", {
            date: memberSince ? formatDate(memberSince, "dd/MM/yyyy") : "—",
          })}
        </span>
      </CardDescription>
    </>
  );
}
